import controller from './dashboard.controller';
import template from './dashboard.view.html';

let DashboardComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DashboardComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/dashboard/dashboard.component.js
 **/